import { type FC, useId } from 'react';

import { theme } from '../../theme';
import Checkbox from '../Checkbox';
import { StyledCardCopy, StyledCardMarkSlot, StyledCardRoot } from '../RadioCard/card.styled';
import Typography from '../Typography';
import type { CheckboxCardProps } from './types';

const CheckboxCard: FC<CheckboxCardProps> = ({
  checked,
  onCheckedChange,
  label,
  description,
  disabled,
  size = 'md',
  variant = 'outline',
  className,
}) => {
  const labelId = useId();
  const descriptionId = useId();

  return (
    <StyledCardRoot className={className} $size={size} $variant={variant} $mark="checkbox">
      <StyledCardMarkSlot $size={size}>
        <Checkbox
          checked={checked}
          onCheckedChange={(next) => onCheckedChange(next)}
          disabled={disabled}
          size={size === 'md' ? 'sm' : 'md'}
          aria-labelledby={labelId}
          aria-describedby={description ? descriptionId : undefined}
        />
      </StyledCardMarkSlot>

      <StyledCardCopy>
        <Typography
          as="span"
          id={labelId}
          variant="body3"
          fontWeight={600}
          color={theme.colors.text.primary}
        >
          {label}
        </Typography>
        {description && (
          <Typography
            as="span"
            id={descriptionId}
            variant="body4"
            color={theme.colors.text.secondary}
          >
            {description}
          </Typography>
        )}
      </StyledCardCopy>
    </StyledCardRoot>
  );
};

CheckboxCard.displayName = 'CheckboxCard';

export default CheckboxCard;
